export default __webpack_public_path__ + "static/PPNeueMontreal-Medium-d9ec371225f7c19bdbb7b9215faa215e.ttf";